import './index.less';
import { CountDownBanner } from './snippets/activity-countdown';
import {activityPicSwiper} from './snippets/activity-pic-swiper';
import PhotovolaticFindOut from "../photovolatic-collection/sections/photovolatic-find-out";
import {RegularBanner} from '../five-kwh-market/sections/five-kwh-banner/index_multi';
import FiveKwhVideo from './snippets/activity-video';
import { ProductsSwiper } from '../index-new/sections/index-new-product'
import { AwardsSwiper } from "../index-new/sections/index-awards";
import { VideoBanner } from "../index-new/sections/index-video-banner";
import { BlogsSwiper } from "../index-new/sections/index-blogs";
import { Scene } from "../jackery-12th-anniversary/sections/jky-12th-scene";
import FiveKwhSwiperTwo from '../five-kwh-market/sections/five-kwh-swiper-two/index'
import {ActivityImage} from "./snippets/activity-image";


activityPicSwiper();
$(document).ready(function() {
    new AwardsSwiper()
    new BlogsSwiper()

    $('.index-function-banner').each(function(){
        const clas = $(this).data('name')
        if (clas) {
            const type = $(`.${clas}`).data('type')
            type === 'countdown' &&  new CountDownBanner({el: $(`.${clas}`), clas});
            type === 'video' && new VideoBanner({el:  $(`.${clas}`), clas});

        }
    })

    $('.index-new-products').each(function(){
        const clas = $(this).data('name')
        clas && new ProductsSwiper({el: $(`.${clas}`), clas})
    })

    $('.count-down-banner').each(function (){
        new CountDownBanner({el: $(this), clas:''});
    })

    document.querySelectorAll('.section-photovolatic-find-out').forEach(item => {
        // 防止重复实例化
        if (item._pId) return

        item._pId = new PhotovolaticFindOut({
            pcDOM: item.querySelector('.findout-pc-swiper'),
            mbDOM: item.querySelector('.findout-mb-swiper'),
        })
    })
    // banner
    try {
        document.querySelectorAll(".five-kwh-banner").forEach((el) => {
          if (el.dataset.initialized !== "true") {
            el.dataset.initialized = "true";
            new RegularBanner(el);
          }
        });
      } catch (error) {
        console.log("new-product RegularBanner error", error)
      }

    $('.activity_matrix').each(function() {
        const matrixGraphList = $(this).find('.product-detail-matrix-graph .matrix-graph-list');
        if (matrixGraphList.children().length === 0) {
            $(this).remove();
        }
    });
    const domWidth = document.body.scrollWidth;
    const lastMediaHighlight = $('.activity_matrix').last();
    if (domWidth > 1024) {
        lastMediaHighlight.css('margin-bottom', '123px');
    } else {
        lastMediaHighlight.css('padding-bottom', '10vw');
    }
    $('.section-matrix-graph .product-detail-matrix-graph').each(function() {
        let columnTemplate, items, gridList;
        if (domWidth > 1024) {
            gridList = $(this).find('.pc-block .matrix-graph-list');
            columnTemplate = gridList.attr('data-grid-columns');
            items = $(this).find('.pc-block .matrix-graph-item');
            gridList.css('grid-template-columns', columnTemplate);
            const columnCount = columnTemplate.split(' ').length;
            items.each(function(index) {
                $(this).css('display', index < columnCount ? 'block' : 'none');
            });
        } else {
            gridList = $(this).find('.mb-block .matrix-graph-list');
            columnTemplate = gridList.attr('data-grid-columns');
            items = $(this).find('.mb-block .matrix-graph-item');
            gridList.css('grid-template-columns', 'repeat(2, 1fr)');
            const columnTemplateNum = Number(columnTemplate);
            if (columnTemplateNum > 1 && columnTemplateNum < 4) {
                switch (columnTemplateNum) {
                    case 2:
                        items.eq(0).css('grid-column', '1 / 3');
                        break;
                    case 3:
                        items.eq(2).css('grid-column', '1 / 3');
                        break;
                }
                items.eq(3).css('display', 'none');
            }
        }
    });
    $('.activity-matrix').css('visibility', 'visible');

    const initSwiper = (selector, swiperClass, pcClass, mbClass, SwiperConstructor) => {
        const $elements = $(selector);
        if ($elements.length === 0) return;
        $elements.each((i, element) => {
            const $currentSwiper = $(element);
            const swiperIndex = i + 1;
            $currentSwiper.addClass(`${swiperClass}-${swiperIndex}`);
            $currentSwiper.find(`.${pcClass}`).addClass(`${pcClass}-${swiperIndex}`);
            $currentSwiper.find(`.${mbClass}`).addClass(`${mbClass}-${swiperIndex}`);
            new SwiperConstructor({
                wrapEl: `.${swiperClass}-${swiperIndex}`,
                pcEl: `.${pcClass}-${swiperIndex}`,
                mbEl: `.${mbClass}-${swiperIndex}`
            });
        });
    };

    new Scene({el: '.five-img-text'})
    new ActivityImage();
    initSwiper('.five-kwh-swiper-two', 'five-kwh-swiper-two', 'five-kwh-two-carousel-pc', 'five-kwh-two-carousel-mb', FiveKwhSwiperTwo);
})

$(function (){
    $('.activity-main-container .five-kwh-item').each(function (){
        const index = $(this).data('index');
        if($(this).hasClass('five-kwh-video')){
            const type = $(this).data('type')
            new FiveKwhVideo(index,type);
        }
    })
})
